export class CorrelationError extends Error {
	correlationId: string;

	constructor(message, correlationId) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(message);

    // Maintains proper stack trace for where our error was thrown (only available on V8/Node.js)
    if ((<any>Error).captureStackTrace) {
      (<any>Error).captureStackTrace(this, this.constructor);
    }

    // Custom debugging information
    this.name = this.constructor.name; // Evaluates to 'CorrelationError'
    this.correlationId = correlationId;
  }
}
